export default "__VITE_ASSET__006SgIgJ__"